module.exports = __webpack_public_path__ + "img/link_icon.5c0626a6.svg";